<template>
  <div class="fromStyle">
    <ul v-if="details != ''" class="info">
      <li>
        <label>员工：</label>
        <p>{{ details.user_name }}</p>
      </li>
      <li>
        <label>项目：</label>
        <p>{{ details.project_name }}</p>
      </li>
    </ul>
    <section>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <!-- --------------- 分割线  ---------------------- -->
        <a-form-model-item label="员工结算-模版" prop="three_type">
          <a-radio-group v-model="form.guard_type">
            <a-radio :value="1">单价</a-radio>
            <a-radio :value="2">阶梯价</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <!-- 单价模版 -->
        <a-form-model-item
          label="结算配置"
          prop="three_type"
          v-show="form.guard_type == 1"
        >
          <table class="configuration">
            <thead>
              <th v-for="(item, i) in configList" :key="i">{{ item.title }}</th>
            </thead>
            <tbody>
              <tr>
                <td v-for="(item, i) in configList" :key="i.isChange">
                  <img
                    @click="changeTaskOnly(item, i)"
                    v-show="item.isChange"
                    src="../../assets/home/xuanzhong.png"
                    alt
                  />
                  <img
                    @click="changeTaskOnly(item, i)"
                    v-show="!item.isChange"
                    src="../../assets/home/weixuanzhong.png"
                    alt
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </a-form-model-item>
        <a-form-model-item
          v-show="basePriceIsShow && form.guard_type == 1"
          label="基础单价"
          prop="guard_base_price"
        >
          <a-input-number v-model="form.guard_base_price" :min="0" />
        </a-form-model-item>
        <a-form-model-item
          v-show="dayIsShow && form.guard_type == 1"
          label="日间价"
          prop="guard_day"
        >
          <a-input-number v-model="form.guard_day" :min="0" />
        </a-form-model-item>
        <a-form-model-item
          v-show="nightIsShow && form.guard_type == 1"
          label="夜间价"
          prop="guard_night"
        >
          <a-input-number v-model="form.guard_night" :min="0" />
        </a-form-model-item>
        <a-form-model-item
          v-show="holidaysIsShow && form.guard_type == 1"
          label="节假日奖励"
          prop="guard_festival"
        >
          <a-input-number v-model="form.guard_festival" :min="0" />
        </a-form-model-item>
        <a-form-model-item
          v-show="fullHoursIsShow && form.guard_type == 1"
          label="满勤天数"
          prop="guard_full_day"
        >
          <a-input-number v-model="form.guard_full_day" :min="0" />
        </a-form-model-item>
        <a-form-model-item
          v-show="fullAmountIsShow && form.guard_type == 1"
          label="满勤奖励"
          prop="guard_full_price"
        >
          <a-input-number v-model="form.guard_full_price" :min="0" />
        </a-form-model-item>
        <a-form-model-item
          v-show="minDaysIsShow && form.guard_type == 1"
          label="小于N天不结算"
          prop="guard_no_day"
        >
          <a-input-number v-model="form.guard_no_day" :min="0" />
        </a-form-model-item>
        <a-form-model-item
          v-show="minOrdersIsShow && form.guard_type == 1"
          label="小于N单不结算"
          prop="guard_no_count"
        >
          <a-input-number v-model="form.guard_no_count" :min="0" />
        </a-form-model-item>
        <a-form-model-item
          v-show="minimumIsShow && form.guard_type == 1"
          label="保底金额"
          prop="guard_protect_price"
        >
          <a-input-number v-model="form.guard_protect_price" :min="0" />
        </a-form-model-item>
        <a-form-model-item
          v-show="maxOrdersIsShow && form.guard_type == 1"
          label="大于N单按保底"
          prop="guard_protect_count"
        >
          <a-input-number v-model="form.guard_protect_count" :min="0" />
        </a-form-model-item>
        <!-- 单价模版 end -->
        <!-- 阶梯模版 -->
        <a-form-model-item
          style="vertical-align: middle"
          v-if="form.guard_type == 2"
          label="阶梯"
        >
          <div v-for="(element, j) in guard_ladder" :key="j">
            <span>最小值&nbsp;&nbsp;</span>
            <a-input-number v-model="element.min" :min="0" />
            <span>最大值&nbsp;&nbsp;</span>
            <a-input-number v-model="element.max" :min="element.min + 1" />
            <a-icon
              @click="addWorkerLadder(j, element.txt)"
              style="font-size: 32px; color: #; vertical-align: middle"
              :type="element.txt == '增加' ? 'plus-square' : 'minus-square'"
            />
          </div>
        </a-form-model-item>
        <a-form-model-item
          v-show="element.max != '' && form.guard_type == 2"
          v-for="(element, j) in guard_ladder"
          :key="j.min"
          style="vertical-align: middle"
          label="区间结算价"
        >
          <span>{{
            element.min + "&nbsp;~&nbsp;" + element.max + "&nbsp;&nbsp;"
          }}</span>
          <a-input-number
            v-model="element.price"
            :min="0"
            style="margin-right: 10px"
          />
          <span>元</span>
        </a-form-model-item>
        <!-- 阶梯模版 end-->
        <!-- --------------- 分割线  ---------------------- -->
        <a-form-model-item
          style="margin-top: 50px"
          :wrapper-col="{ span: 12, offset: 6 }"
        >
          <a-button type="primary" @click="handleSubmit">提交</a-button>
          <!-- <a-button style="margin-left: 10px;" @click="resetForm">Reset</a-button> -->
        </a-form-model-item>
      </a-form-model>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { pcaa } from "area-data";
export default {
  inject: ["reload"],
  data() {
    return {
      formLayout: "horizontal",
      form: {
        three_type: 1,
        three_base_price: "",
        guard_type: 1,
        guard_base_price: "",
        guard_day: "",
        guard_night: "",
        guard_festival: "",
        guard_full_day: "",
        guard_full_price: "",
        guard_no_day: "",
        guard_no_count: "",
        guard_protect_count: "",
        guard_protect_price: ""
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      proList: [],
      three_ladder: [{ min: 0, max: "", txt: "增加", price: "" }],
      guard_ladder: [{ min: 0, max: "", txt: "增加", price: "" }],
      rules: {
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ]
      },
      configList: [
        {
          title: "基础单价",
          change: false,
          id: "guard_base_price"
        },
        {
          title: "日间价|夜间价",
          change: false,
          id: "guard_day_night"
        },
        {
          title: "节假日奖励",
          change: false,
          id: "guard_festival"
        },
        {
          title: "满勤奖励",
          change: false,
          id: "guard_fullHours"
        },
        {
          title: "小于N天不结算",
          change: false,
          id: "guard_minDays"
        },
        {
          title: "小于N单不结算",
          change: false,
          id: "guard_minOrders"
        },
        {
          title: "保底金额",
          change: false,
          id: "guard_minimum"
        },
        {
          title: "大于N单按保底",
          change: false,
          id: "guard_maxOrders"
        }
      ],
      basePriceIsShow: false,
      dayIsShow: false,
      nightIsShow: false,
      holidaysIsShow: false,
      fullHoursIsShow: false,
      fullAmountIsShow: false,
      minDaysIsShow: false,
      minOrdersIsShow: false,
      minimumIsShow: false,
      maxOrdersIsShow: false,
      details: {}
    };
  },
  mounted() {
    this.getPro(); //获取客户列表
    if (this.settleDetails != undefined) {
      this.getDetails();
    }
  },
  props: {
    settleDetails: {}
  },
  watch: {
    settleDetails() {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.details = this.settleDetails;
      // console.log(this.details);
      this.form = {
        guard_type: this.details.config_data.guard_type,
        guard_base_price: Number(this.details.config_data.guard_base_price),
        guard_day: Number(this.details.config_data.guard_day),
        guard_night: Number(this.details.config_data.guard_night),
        guard_festival: Number(this.details.config_data.guard_festival),
        guard_full_day: Number(this.details.config_data.guard_full_day),
        guard_full_price: Number(this.details.config_data.guard_full_price),
        guard_no_day: Number(this.details.config_data.guard_no_day),
        guard_no_count: Number(this.details.config_data.guard_no_count),
        guard_protect_count: Number(
          this.details.config_data.guard_protect_count
        ),
        guard_protect_price: Number(
          this.details.config_data.guard_protect_price
        )
      };
      this.configList.forEach((item, index) => {
        switch (item.id) {
          case "guard_base_price":
            Number(this.details.config_data.guard_base_price) == 0
              ? (item.isChange = false)
              : (item.isChange = true);
            break;
          case "guard_day_night":
            Number(this.details.config_data.guard_night) == 0
              ? (item.isChange = false)
              : (item.isChange = true);
            break;
          case "guard_festival":
            Number(this.details.config_data.guard_festival) == 0
              ? (item.isChange = false)
              : (item.isChange = true);
            break;
          case "guard_fullHours":
            Number(this.details.config_data.guard_full_price) == 0
              ? (item.isChange = false)
              : (item.isChange = true);
            break;
          case "guard_minDays":
            Number(this.details.config_data.guard_no_day) == 0
              ? (item.isChange = false)
              : (item.isChange = true);
            break;
          case "guard_minOrders":
            Number(this.details.config_data.guard_full_price) == 0
              ? (item.isChange = false)
              : (item.isChange = true);
            break;
          case "guard_minimum":
            Number(this.details.config_data.guard_protect_price) == 0
              ? (item.isChange = false)
              : (item.isChange = true);
            break;
          case "guard_maxOrders":
            Number(this.details.config_data.guard_protect_count) == 0
              ? (item.isChange = false)
              : (item.isChange = true);
            break;
        }
      });

      // console.log(this.configList);
      Number(this.details.config_data.guard_base_price) == 0
        ? (this.basePriceIsShow = false)
        : (this.basePriceIsShow = true);
      Number(this.details.config_data.guard_day) == 0
        ? (this.dayIsShow = false)
        : (this.dayIsShow = true);
      Number(this.details.config_data.guard_night) == 0
        ? (this.nightIsShow = false)
        : (this.nightIsShow = true);
      Number(this.details.config_data.guard_festival) == 0
        ? (this.holidaysIsShow = false)
        : (this.holidaysIsShow = true);
      Number(this.details.config_data.guard_full_price) == 0
        ? (this.fullAmountIsShow = false)
        : (this.fullAmountIsShow = true);
      Number(this.details.config_data.guard_full_day) == 0
        ? (this.fullHoursIsShow = false)
        : (this.fullHoursIsShow = true);
      Number(this.details.config_data.guard_no_day) == 0
        ? (this.minDaysIsShow = false)
        : (this.minDaysIsShow = true);
      Number(this.details.config_data.guard_no_count) == 0
        ? (this.minOrdersIsShow = false)
        : (this.minOrdersIsShow = true);
      Number(this.details.config_data.guard_protect_price) == 0
        ? (this.minimumIsShow = false)
        : (this.minimumIsShow = true);
      Number(this.details.config_data.guard_protect_count) == 0
        ? (this.maxOrdersIsShow = false)
        : (this.maxOrdersIsShow = true);
      // 甲方阶梯价
      if (
        this.details.config_data.three_ladder != undefined &&
        this.details.config_data.three_ladder != ""
      ) {
        this.three_ladder = this.details.config_data.three_ladder;
        this.three_ladder.forEach((item, index) => {
          index == 0 ? (item.txt = "增加") : (item.txt = "减少");
        });
      }
      //员工阶梯价
      if (
        this.details.config_data.guard_ladder != undefined &&
        this.details.config_data.guard_ladder != ""
      ) {
        this.guard_ladder = this.details.config_data.guard_ladder;
        this.guard_ladder.forEach((item, index) => {
          index == 0 ? (item.txt = "增加") : (item.txt = "减少");
        });
      }
      this.$forceUpdate();
    },
    changeTaskOnly(item, i) {
      this.configList[i].isChange = !this.configList[i].isChange;
      switch (item.id) {
        case "guard_base_price":
          this.basePriceIsShow = !this.basePriceIsShow;
          this.form.guard_base_price = "";
          break;
        case "guard_day_night":
          this.dayIsShow = !this.dayIsShow;
          this.nightIsShow = !this.nightIsShow;
          this.form.guard_day = "";
          this.form.guard_night = "";
          break;
        case "guard_festival":
          this.holidaysIsShow = !this.holidaysIsShow;
          this.form.guard_festival = "";
          break;
        case "guard_fullHours":
          this.fullHoursIsShow = !this.fullHoursIsShow;
          this.fullAmountIsShow = !this.fullAmountIsShow;
          this.form.guard_full_day = "";
          this.form.guard_no_count = "";
          break;
        case "guard_minDays":
          this.minDaysIsShow = !this.minDaysIsShow;
          this.form.guard_no_day = "";
          break;
        case "guard_minOrders":
          this.minOrdersIsShow = !this.minOrdersIsShow;
          this.form.guard_no_count = "";
          break;
        case "guard_minimum":
          this.minimumIsShow = !this.minimumIsShow;
          this.form.guard_protect_price = "";
          break;
        case "guard_maxOrders":
          this.maxOrdersIsShow = !this.maxOrdersIsShow;
          this.form.guard_protect_count = "";
          break;
      }
      this.$forceUpdate();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    addLadder(index, txt) {
      if (txt == "增加") {
        if (this.three_ladder[this.three_ladder.length - 1].max != "") {
          this.three_ladder.push({
            min: this.three_ladder[this.three_ladder.length - 1].max,
            max: "",
            txt: "减少",
            price: ""
          });
        } else {
          this.$message.error("请先填写最大值！");
        }
      } else {
        this.three_ladder.splice(index, 1);
      }
    },
    addWorkerLadder(index, txt) {
      if (txt == "增加") {
        if (this.guard_ladder[this.guard_ladder.length - 1].max != "") {
          this.guard_ladder.push({
            min: this.guard_ladder[this.guard_ladder.length - 1].max,
            max: "",
            txt: "减少",
            price: ""
          });
        } else {
          this.$message.error("请先填写最大值！");
        }
      } else {
        this.guard_ladder.splice(index, 1);
      }
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 4
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      //   console.log(attr_config);
      this.$refs.ruleForm.validate(valid => {
        //   console.log(pramas)
        if (valid) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.retail +
            "Guard/setUserProjectAccountConfig";
          let ownerList = this.three_ladder;
          ownerList.forEach(item => {
            delete item.txt;
          });
          let guardList = this.guard_ladder;
          guardList.forEach(item => {
            delete item.txt;
          });
          // console.log(ownerList);
          let params = {
            project_id: this.details.project_id,
            user_id: this.details.id,
            token: window.localStorage.getItem("xnwfPcToken"),
            guard_type: this.form.guard_type,
            guard_ladder: JSON.stringify(guardList),
            guard_base_price: this.form.guard_base_price,
            guard_day: this.form.guard_day,
            guard_night: this.form.guard_night,
            guard_no_day: this.form.guard_no_day,
            guard_no_count: this.form.guard_no_count,
            guard_festival: this.form.guard_festival,
            guard_full_day: this.form.guard_full_day,
            guard_full_price: this.form.guard_full_price,
            guard_protect_count: this.form.guard_protect_count,
            guard_protect_price: this.form.guard_protect_price
          };
          if (this.form.guard_type == 1) {
            delete params.guard_ladder;
          }
          if (this.form.guard_type == 2) {
            delete params.guard_base_price;
            delete params.guard_day;
            delete params.guard_night;
            delete params.guard_no_day;
            delete params.guard_no_count;
            delete params.guard_festival;
            delete params.guard_full_day;
            delete params.guard_full_price;
            delete params.guard_protect_count;
            delete params.guard_protect_price;
          }
          // console.log(params);
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.$refs.ruleForm.resetFields();
                this.$emit("hideInEdit", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 30px 4% 0;
  padding-bottom: 30px;
  .info {
    margin: auto;
    text-align: center;
    > li {
      margin-bottom: 10px;
      label,
      p {
        display: inline-block;
        font-size: 14px;
      }
    }
  }

  h3 {
    margin: 30px 4% 40px;
    // width: 25%;
    // text-align: right;
  }
  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 24%;
    margin-top: 30px;
    p {
      width: 90px;
      margin-right: 40px;
    }
  }
  h4 {
    width: 20.84%;
    text-align: right;
    margin: 20px 0 10px;
  }
  .ant-form-item {
    margin-bottom: 10px;
  }
  .ant-input-number {
    margin-right: 30px;
  }
  .yuan {
    font-style: normal;
    font-size: 12px;
    display: inline-block;
    margin-right: 4px;
    color: #999;
  }
  .configuration {
    width: 100%;
    td,
    th {
      border: 1px solid #d9d9d9;
      font-size: 14px;
      padding: 4px 10px;
      text-align: center;
      img {
        height: 20px;
      }
    }
  }
}
</style>

<style lang="less">
.fromStyle {
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
  }
  .area-select {
    line-height: 32px;
  }
  .area-select.medium {
    width: 142px;
  }
}
</style>
